// -----------------------------------------------------------
// FloraIQ — Aba Regras de Validação
// -----------------------------------------------------------
// Lista apenas as regras implementadas na view qualidade.v_validation_issues_sql.
// A contagem e de inconsistencias abertas (dado real); a view nao informa
// quantos registros foram avaliados, entao nao ha percentual de conformidade.

import type { Inconsistency } from "@/types/ui-models";
import { QUALITY_RULES, QUALITY_RULE_GROUP_LABELS } from "@/config/qualidade-3d-config";
import { SeverityBadge } from "./QualityStatusBadge";

interface ValidationRulesTableProps {
  issues: Inconsistency[];
  loading: boolean;
  error: string | null;
}

export default function ValidationRulesTable({ issues, loading, error }: ValidationRulesTableProps) {
  const openByRule = issues.reduce<Record<string, number>>((acc, i) => {
    acc[i.regra] = (acc[i.regra] ?? 0) + 1;
    return acc;
  }, {});

  const openCell = (code: string) => {
    if (loading) return "…";
    if (error) return "—";
    return (openByRule[code] ?? 0).toLocaleString("pt-BR");
  };

  return (
    <div className="space-y-4">
      <p className="text-xs text-foreground-500">
        {QUALITY_RULES.length} regras implementadas no banco. Regras novas são criadas por migration, não pela tela.
      </p>

      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Código</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Regra</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Grupo</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Severidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Registro avaliado</th>
              <th className="text-right px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Abertas</th>
            </tr>
          </thead>
          <tbody>
            {QUALITY_RULES.map((r) => (
              <tr key={r.code} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5 font-mono text-foreground-700 whitespace-nowrap">{r.code}</td>
                <td className="px-3 py-2.5">
                  <p className="font-medium text-foreground-800">{r.name}</p>
                  <p className="text-foreground-500">{r.description}</p>
                </td>
                <td className="px-3 py-2.5 text-foreground-600 whitespace-nowrap">{QUALITY_RULE_GROUP_LABELS[r.group]}</td>
                <td className="px-3 py-2.5"><SeverityBadge severity={r.severity} /></td>
                <td className="px-3 py-2.5 font-mono text-foreground-500 whitespace-nowrap">{r.entity}</td>
                <td className="px-3 py-2.5 text-right font-semibold text-foreground-800">{openCell(r.code)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
